import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  getBusinessProfile,
  getSocialMedia,
  patchBusinessProfile,
  patchSocialMedia,
  uploadBusinessProfileImage,
} from '/redux/action/coach.action';
import {
  businessProfile,
  hasBusinessProfile,
  hasSocialMedia,
  isBusinessProfileError,
  isBusinessProfileLoading,
  isBusinessProfileSaving,
  isSocialMediaError,
  isSocialMediaLoading,
  isSocialMediaSaving,
  socialMedia,
} from '/redux/selector/coach.selector';

import {
  BusinessProfileApiPayload,
  SocialMediaApiPayload,
} from '../ManageMySite.types';

import {ManageMySiteContainer} from './ManageMySiteContainer';

export default connect(
  createStructuredSelector({
    businessProfile: businessProfile,
    hasBusinessProfile: hasBusinessProfile,
    isBusinessProfileLoading: isBusinessProfileLoading,
    isBusinessProfileSaving: isBusinessProfileSaving,
    isBusinessProfileError: isBusinessProfileError,
    socialMedia: socialMedia,
    hasSocialMedia: hasSocialMedia,
    isSocialMediaLoading: isSocialMediaLoading,
    isSocialMediaSaving: isSocialMediaSaving,
    isSocialMediaError: isSocialMediaError,
  }),
  dispatch => ({
    getBusinessProfile: () =>
      // @ts-expect-error
      dispatch(getBusinessProfile()),
    patchBusinessProfile: (payload: Partial<BusinessProfileApiPayload>) =>
      // @ts-expect-error
      dispatch(patchBusinessProfile(payload)),
    getSocialMedia: () =>
      // @ts-expect-error
      dispatch(getSocialMedia()),
    patchSocialMedia: (payload: Partial<SocialMediaApiPayload>) =>
      // @ts-expect-error
      dispatch(patchSocialMedia(payload)),
    uploadBusinessProfileImage: (payload: {
      imageType: 'avatar' | 'before' | 'after';
      uri: string;
    }) =>
      // @ts-expect-error
      dispatch(uploadBusinessProfileImage(payload)),
  }),
)(ManageMySiteContainer);
